import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function VideoSection() {
  const { ref, isVisible } = useScrollAnimation();
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section className="py-14 md:py-24 px-5 md:px-8 bg-white">
      <div ref={ref} className="max-w-5xl mx-auto">
        {/* 헤더 */}
        <div
          className={`text-center mb-8 md:mb-14 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-xs font-semibold mb-3 md:mb-4">
            스피루리나 소개
          </span>
          <h2
            className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            <strong>자연담은 스피루리나</strong>를 영상으로 만나보세요
          </h2>
          <p className="text-xs md:text-sm text-gray-500 max-w-xl mx-auto leading-relaxed">
            35억 년의 자연이 담긴 슈퍼푸드, 스피루리나의 놀라운 효능과 자연담은의 엄격한 품질 관리를 직접 확인하세요.
          </p>
        </div>

        {/* 영상 플레이어 */}
        <div
          className={`relative rounded-2xl overflow-hidden shadow-xl ${
            isVisible ? 'animate-fade-in-up' : 'opacity-0'
          }`}
          style={{ animationDelay: '150ms' }}
        >
          {!isPlaying ? (
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/08ba8aad7c986f684ee13395f1c78f9b.jpg"
                alt="스피루리나 소개 영상 썸네일"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-black/40" />
              <button
                onClick={() => setIsPlaying(true)}
                className="absolute inset-0 flex flex-col items-center justify-center gap-4 group cursor-pointer whitespace-nowrap"
                aria-label="영상 재생"
              >
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/90 group-hover:bg-white flex items-center justify-center shadow-2xl transition-all duration-300 group-hover:scale-110">
                  <i className="ri-play-fill text-2xl md:text-3xl text-emerald-600 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center ml-1"></i>
                </div>
                <span className="text-white text-sm md:text-base font-semibold drop-shadow-md">
                  영상으로 스피루리나 알아보기
                </span>
              </button>
              <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6 flex items-center gap-2 bg-black/50 backdrop-blur-sm rounded-full px-3 py-1.5">
                <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></div>
                <span className="text-white text-xs font-medium">자연담은 공식 소개 영상</span>
              </div>
            </div>
          ) : (
            <div className="relative w-full bg-black" style={{ paddingBottom: '56.25%' }}>
              <video
                className="absolute inset-0 w-full h-full"
                src="https://storage.readdy-site.link/project_files/fab39877-057d-4165-9475-a35374cb4014/cafc6662-ab2d-4ee4-b6fc-0030de67daed_jtbc.mp4?v=a25ea19941fbf93a3ec7f859af6ff1e4"
                controls
                autoPlay
                playsInline
              >
                브라우저가 영상 재생을 지원하지 않습니다.
              </video>
            </div>
          )}
        </div>

        {/* 하단 포인트 3가지 */}
        <div
          className={`grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mt-8 md:mt-12 ${
            isVisible ? 'animate-fade-in-up' : 'opacity-0'
          }`}
          style={{ animationDelay: '300ms' }}
        >
          {[
            {
              icon: 'ri-microscope-line',
              title: '과학적 검증',
              desc: '국내외 연구기관의 임상 데이터로 입증된 효능',
            },
            {
              icon: 'ri-leaf-line',
              title: '청정 자연 원료',
              desc: '오염 없는 청정 환경에서 재배된 100% 유기농 스피루리나',
            },
            {
              icon: 'ri-shield-check-line',
              title: '엄격한 품질 관리',
              desc: 'HACCP 인증 시설에서 위생적으로 생산·포장',
            },
          ].map((item, i) => (
            <div
              key={item.title}
              className="flex items-start gap-3 md:gap-4 p-4 md:p-5 rounded-xl bg-stone-50"
              style={{ animationDelay: `${300 + i * 100}ms` }}
            >
              <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-lg text-emerald-600 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <div>
                <p className="text-sm font-bold text-gray-900 mb-1">{item.title}</p>
                <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
